import api from "../../../../../api";

export const requestGetNewPartRequests = (limit, offset) => {
  return api.get(`/newpartrequests/${limit}/${offset}`);
};

export const requestGetPartRequestsByState = (state, array_of_car_objects = []) => {
  return api.post("/partrequest/findandcountbyselection", {
    state,
    array_of_car_objects,
  });
};



export const requestGetPartRequestDetails = (id) => {
  return api.get(`/partrequestseller/${id}`);
};